module.exports = __webpack_public_path__ + "static/media/dummy2.e77a5906.jpg";